import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalized,
} from 'vue-router';

import { checkUserCompanies, registerGuard } from '@/router/guard';
import RouteName from '@/router/types';

import LoginFailedPage from '@/pages/BoilerplateLoginFailed.page.vue';
import HomePage from '@/pages/home/HomePage.page.vue';
import MainLayoutPage from '@/pages/MainLayout.page.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APPLICATION_BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      redirect: { path: '/' },
    },
    {
      path: '/',
      component: MainLayoutPage,
      redirect: { path: '/' },
      beforeEnter: (
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
      ) => checkUserCompanies(from, to, next),
      children: [
        {
          path: '',
          name: RouteName.HOME,
          component: HomePage,
        },
      ],
      meta: {
        requiresAuth: import.meta.env.VITE_AUTH_REQUIRED === 'true',
      },
    },
    {
      path: '/loginFailed',
      name: RouteName.LOGIN_FAILED,
      component: LoginFailedPage,
    },
  ],
});

registerGuard(router);

export default router;
